var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('common-table',{ref:"table",attrs:{"url":_vm.url,"table-columns":_vm.tableColumns,"form-fields":_vm.formFields,"operate":_vm.operate,"permission":_vm.permission,"searchs":_vm.searchs}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }